


























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';
import Modal from '@/layouts/back-office/elements/modals/Modal.vue';
import {ConditionState, Resource, RightClickMenuOptions} from '@/types/gripper';
import ConditionsSelector from '@/layouts/gripper/components/ConditionsSelector.vue';
import {JobDataset_job_dataset_conditions} from '@/types/intrador';
import ImageLazyLoader from '@/layouts/gripper/components/ImageLazyLoader.vue';

@Component({
  components: {
    ImageLazyLoader,
    ConditionsSelector,
    Modal,
    HotkeyListener,
    VueSimpleContextMenu,
  },
})
export default class ImagesGrid extends Vue {

  @Prop(Object) public currentOption!: any;
  @Prop(Array) public imagesData!: Resource[];
  @Prop(Array) public conditions!: JobDataset_job_dataset_conditions[];
  @Prop(Boolean) public isDragging!: boolean;
  @Prop(Number) public currentPage!: number;
  @Prop(String) public initHeight?: string;
  @Prop(Number) public initColSize?: number;
  @Prop(Boolean) public turnOffHotkeys?: boolean;
  @Prop(Array) public rightClickMenuOptionsOverride?: [];

  private imgHeight: string = this.initHeight || '250px';
  private colSize: number = this.initColSize || 4;

  private imageSource: string | null = null;

  private selectedResourceID: string | null = null;
  private selectedResourceArray: string[] = [];

  private bulkDeleteMode: boolean = false;
  private resourcesPendingForDeleteArray: Resource[] = [];
  private conditionsStates: ConditionState[] = [];

  private rightClickMenuOptions: RightClickMenuOptions[] = this.rightClickMenuOptionsOverride || [
    {
      name: 'Uitvergrote foto',
      slug: 'more_detail',
    },
    {
      name: 'Verwijderen uit dataset',
      slug: 'delete_from_dataset',
    },
    {
      name: 'Bekijk resource',
      slug: 'view_resource',
    },
  ];

  public setSelectedResourceId(id: string) {
    this.selectedResourceID = id;
    this.selectedResourceArray = [id];
  }

  private getColClass() {
    const large = 12 / this.colSize;
    const medium = 12 / Math.max((this.colSize - 1), 1);
    const small = 12 / Math.max((this.colSize - 2), 1);

    return `col-lg-${large} col-md-${medium} col-${small}`;
  }

  @Watch('initHeight')
  private onHeightChange() {
    if (typeof this.initHeight === 'string') {
      this.imgHeight = this.initHeight;
    }
  }

  @Watch('initColSize')
  private onColSizeChange() {
    if (this.initColSize) {
      this.colSize = this.initColSize;
    }
  }

  private dragging(resource: Resource) {
    if (this.isDragging) {
      this.onMarkResource(resource);
    }

    let video = this.$refs['video' + resource.id];
    if (Array.isArray(video)) {
      video = video[0];
    }
    if (video instanceof HTMLVideoElement) {
      video.play();
    }
  }

  private pause(resource: Resource) {
    let video = this.$refs['video' + resource.id];
    if (Array.isArray(video)) {
      video = video[0];
    }
    if (video instanceof HTMLVideoElement) {
      video.pause();
    }
  }

  private created() {
    const firstId = this.imagesData[0].id;
    this.selectedResourceID = firstId;
    this.selectedResourceArray = [firstId];

    // dont show a selected item (for hotkeys), since hotkeys are turned off when we have flexible cols
    if (this.turnOffHotkeys) {
      this.selectedResourceID = null;
      this.selectedResourceArray = [];
    }
  }

  private prettyPrint(value: any): any {
    switch (value) {
      case '1':
        return 'Ja';
      case '0':
        return 'Nee';
    }

    return value;
  }

  private createBackgroundString(colorString: string | null) {
    if (!colorString || colorString === '') {
      return '#FFF';
    }

    if (colorString && colorString !== '') {
      const rgbAColorOpaque = this.shadeColor(colorString, 80);
      return `repeating-linear-gradient(-55deg, ${colorString}, ${colorString} 10px,
        ${rgbAColorOpaque} 10px, ${rgbAColorOpaque} 20px)`;
    }
  }

  private shadeColor(color: string, percent: number) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = Math.round(R * (100 + percent) / 100);
    G = Math.round(G * (100 + percent) / 100);
    B = Math.round(B * (100 + percent) / 100);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    const RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
    const GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
    const BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

    return '#' + RR + GG + BB;
  }

  private onRightClickImageInGrid(event: any, item: any) {
    (this.$refs.rightClickMenu as any).showMenu(event, item);
  }

  private onRightClickMenuEntryClick(method: any, event: any) {
    if (method === 'CTRLEvent') {
      this.imageSource = event;
      this.open();
    } else {
      if (method.option.slug === 'delete_from_dataset') {
        this.startDeleteForResourceProc(method.item.id);
      } else if (method.option.slug === 'more_detail') {
        this.imageSource = method.item.url;
        this.open();
      } else if (method.option.slug === 'view_resource') {
        const url = new URL('/nova/resources/resources/' + method.item.id, process.env.VUE_APP_API_DOMAIN!).href;
        window.open(url, '_blank');
      }
    }
  }

  private onMarkResource(resource: Resource | Resource[]) {
    if (this.bulkDeleteMode) {
      if (resource as Resource) {
        // Lets toggle remove/add depending on whether this resource was already added or removed respectively
        if (this.resourceIsPendingInBulkDeleteOperation(resource as Resource)) {
          this.removeResourceFromPendingBulkDeleteArray(resource as Resource);
        } else {
          this.addResourceToPendingBulkDelete(resource as Resource);
        }

        this.selectedResourceID = (resource as Resource).id;
        this.selectedResourceArray = [this.selectedResourceID];
      }
    } else {
      if (resource as Resource) {
        this.selectedResourceID = (resource as Resource).id;
        this.selectedResourceArray = [this.selectedResourceID];
      }
      this.$emit('resourceMarked', resource);
    }
  }


  private keyUp(origin: KeyboardEvent) {
    if (this.turnOffHotkeys) {
      return false;
    }
    // find the index of the object that is currently selected
    const indexInArray = this.imagesData.findIndex((i: any) => i.id === this.selectedResourceID);

    switch (origin.key) {
      case 'ArrowRight': {
        // if we haven't reached the last item yet
        if (this.selectedResourceID !== this.imagesData[this.imagesData.length - 1].id) {
          this.selectedResourceID = this.imagesData[indexInArray + 1].id;
          if (origin.shiftKey) {
            this.selectedResourceArray.push(this.selectedResourceID);

          } else {
            this.selectedResourceArray = [this.selectedResourceID];
          }
          this.fixScrolling();
        } else {
          this.$emit('onPageChangeEvent', this.currentPage + 1);
        }
        break;
      }
      case 'ArrowLeft': {
        // Check if we are not on the first item
        if (this.selectedResourceID !== this.imagesData[0].id) {
          this.selectedResourceID = this.imagesData[indexInArray - 1].id;
          if (origin.shiftKey) {
            this.selectedResourceArray.push(this.selectedResourceID);
          } else {
            this.selectedResourceArray = [this.selectedResourceID];
          }
          this.fixScrolling();
        }
        break;
      }
      case 'ArrowDown': {
        // Check if we can traverse to a lower row
        if (indexInArray + (this.colSize) <= this.imagesData.length - 1) {
          this.selectedResourceID = this.imagesData[indexInArray + (this.colSize)].id;
          if (origin.shiftKey) {
            if (this.selectedResourceArray.length < 1) {
              this.selectedResourceArray.splice(indexInArray, 1);
            } else {
              this.selectedResourceArray.push(this.selectedResourceID);
            }
          } else {
            this.selectedResourceArray = [this.selectedResourceID];
          }
          this.fixScrolling();
        }
        break;
      }
      case 'ArrowUp': {
        // Check if we can traverse to an upper row
        if (indexInArray - (this.colSize) >= 0) {
          this.selectedResourceID = this.imagesData[indexInArray - (this.colSize)].id;
          if (origin.shiftKey) {
            if (this.selectedResourceArray.length < 1) {
              this.selectedResourceArray.splice(indexInArray, 1);
            } else {
              this.selectedResourceArray.push(this.selectedResourceID);
            }
          } else {
            this.selectedResourceArray = [this.selectedResourceID];
          }
          this.fixScrolling();
        }
        break;
      }
      case 'Enter': {
        if (indexInArray >= 0) {
          const resourcesSelected = this.imagesData.filter((resourceData) =>
            this.selectedResourceArray.includes(resourceData.id));
          resourcesSelected.forEach((resourceSelected) => {
            this.onMarkResource(resourceSelected);
          });
        }
        break;
      }
      case 'Control': {
        this.close();
        break;
      }
      case 'Shift': {
        this.startDeleteForResourceProc(null);
        break;
      }
    }
  }

  private fixScrolling() {
    this.$nextTick(() => {
      if (this.selectedResourceID) {
        const selectedItem = (this.$refs.imagecontainer as Element[]).find((item: any) => item.classList.contains('selectedItem'));
        if (selectedItem) {
          selectedItem.scrollIntoView(true);
          selectedItem.scrollIntoView({block: 'center'});
        }
      }
    });
  }

  private keyDown(origin: KeyboardEvent) {
    if (this.turnOffHotkeys) {
      return false;
    }

    const indexInArray = this.imagesData.findIndex((i: any) => i.id === this.selectedResourceID);

    switch (origin.key) {
      case 'Control': {
        const resource = this.imagesData[indexInArray];
        if (resource) {
          this.onRightClickMenuEntryClick('CTRLEvent', resource.url);
        }
        break;
      }
      case 'Shift': {
        this.bulkDeleteMode = true;
        break;
      }
    }
  }

  private open() {
    (this.$refs.modal as Modal).open();
  }

  private close() {
    (this.$refs.modal as Modal).close();
  }

  private addResourceToPendingBulkDelete(resource: Resource): void {
    this.resourcesPendingForDeleteArray.push(resource);
  }

  private removeResourceFromPendingBulkDeleteArray(resource: Resource): void {
    this.resourcesPendingForDeleteArray = this.resourcesPendingForDeleteArray.filter((r: Resource) =>
      r.id !== resource.id);
  }

  private resourceIsPendingInBulkDeleteOperation(resource: Resource) {
    return this.resourcesPendingForDeleteArray.some((r: Resource) => r.id === resource.id);
  }

  private startDeleteForResourceProc(resourceID: string | null) {
    this.askUserForNegativeConditionOptions(resourceID);
  }

  private askUserForNegativeConditionOptions(resourceID: string | null) {
    // if we are in multi-delete mode and we have selected atleast
    if (this.bulkDeleteMode && this.resourcesPendingForDeleteArray.length > 0) {
      (this.$refs.conditionsSelector as any).open(null);
    }

    if (!this.bulkDeleteMode && resourceID) {
      (this.$refs.conditionsSelector as any).open(resourceID);
    }
  }

  private finishSelectingConditions(conditionsStates: [ConditionState], resourceID: string) {
    this.conditionsStates = conditionsStates;
    if (!this.bulkDeleteMode) {
      this.deleteFromDataset(this.getResourceWithID(resourceID));
    } else {
      this.performBulkDelete();
    }
  }

  private performBulkDelete() {
    this.resourcesPendingForDeleteArray.forEach((resource: Resource) => {
      this.deleteFromDataset(resource);
    });

    this.endBulkDeleteUIMode();
  }

  private endBulkDeleteUIMode() {
    this.resourcesPendingForDeleteArray = [];
    this.bulkDeleteMode = false;
  }

  private getResourceWithID(id: string) {
    const indexInArray = this.imagesData.findIndex((i: Resource) => i.id === id);
    return this.imagesData[indexInArray];
  }

  private deleteFromDataset(resource: Resource) {
    this.$emit('deleteFromDataset', resource, this.conditionsStates);
  }

  private getImage(url: string) {
    if (url.includes('/inspection/objects')) {
      return this.replaceNth(url, 'images', 'thumbs', 2);
    }

    return url;
  }

  private replaceNth(s: string, f: string, r: string, n: number) {
    // From the given string s, replace f with r of nth occurrence
    return s.replace(RegExp('^(?:.*?' + f + '){' + n + '}'), (x: any) => x.replace(RegExp(f + '$'), r));
  }

}
